var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"has-full-height notranslate d-flex flex-column"},[_c('v-main',{staticClass:"main-container"},[_c('ToolBar',[_c('HeaderToolbar')],1),_c('div',{staticClass:"has-full-height mt-2"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }